import { inject, Injectable } from '@angular/core';
import { BossAuthTokenService } from '../../services/boss-auth-token.service';
import { FireAuthService } from '../../services/fire-auth.service';
import { BossAuthService } from '../../services/boss-auth.service';
import { Alert, AlertMode } from '../../schemas/alert';
import { AlertService } from './alert.service';

@Injectable({
  providedIn: 'root',
})
export class HandleErrorsService {
  private bossAuthTokenService = inject(BossAuthTokenService);
  private fireAuthService = inject(FireAuthService);
  private bossAuthService = inject(BossAuthService);
  private alertService = inject(AlertService);

  constructor() {}

  async handleErrors(error: any) {
    const message = await this.checkError(error);
    const alert = new Alert();
    alert.message = message;

    if (message === 'FORBIDDEN') alert.mode = AlertMode.DISMISSIBLE;
    this.alertService.alert.set(alert);
  }

  async checkError(response: any) {
    const { errors } = response;
    console.log('ERROR RESPONSE:', response);
    const code =
      errors?.[0]?.extensions?.code ||
      response.code ||
      response.error.code ||
      'TOKEN_EXPIRED';
    console.log('ERROR CODE:', code);
    switch (code) {
      case 'FORBIDDEN':
        // return this.initializeSession();
        // await this.bossAuthService.signOut();
        // return this.fireAuthService.signOut();
        alert('FORBIDDEN!');
        return 'FORBIDDEN';
      case 'TOKEN_EXPIRED':
        // try {
        //   await this.refreshTokens();
        //   return 'REFRESHED';
        // } catch (refreshError) {
        //   console.log('Token refresh failed', refreshError);
        //   await this.fireAuthService.signOut();
        //   return 'TOKEN_EXPIRED';
        // }
        if (this.bossAuthTokenService.get()) {
          await this.bossAuthService.signOut();
        }
        await this.fireAuthService.signOut();
        return 'Your session has expired.';
      case 'BOSS_AUTH_INVALID_TOKEN':
        return 'Sorry, your session has expired.';
      case 'UNAUTHORIZED':
        await this.bossAuthService.signOut();
        await this.fireAuthService.signOut();
        return 'You are not authorized to perform this action.';
      case 'RECAPTCHA_FAILED':
        location.reload();
        return 'Something went wrong.';
      case 'FAILED_TO_SEND_MESSAGE':
        return 'An error occurred while sending the message. Please retry.';
      case 'INVALID_CREDENTIALS':
        return 'Invalid credentials. Please check your email and password or reset your password.';
      case 'INVALID_USER':
        return 'Invalid user.';
      case 'RECORD_NOT_UNIQUE':
        return 'Record not unique.';
      case undefined:
        return errors?.message || response.error.message;
      default:
        return this.fireAuthService.authErrorHandler(response);
    }
  }
}
